export enum DistanceUnit {
    KM = 'KM',
    MI = 'MI'
}

export const defaultDistanceUnit: DistanceUnit = DistanceUnit.KM;